import { writable } from "svelte/store";
import { cloneDeep } from "lodash";

const defaultState = {
  banners: [],
  listId: null,
  bannerFilterData: null,
  page: null,
};

export const QuickOrderListBannersStore = writable(cloneDeep(defaultState));

export const clearQuickOrderListBanners = () => {
  QuickOrderListBannersStore.set(cloneDeep(defaultState));
};
